export default __webpack_public_path__ + "static/media/banner1.790f9991.jpg";